import React from "react"
// import Video from "react-video-js-player"
import ReactPlayer from "react-player"
import augnexImagePath from "../../img/augnex.jpeg"
import augnexImagePath2 from "./images/augnexWelcome.jpeg"
import augnexImagePath3 from "./images/augnexMap.jpeg"
import augnexImagePath4 from "./images/augnexMap1.jpeg"
import augnexVideoPath1 from "./images/Augnex4.mp4"
import augnexVideoPath2 from "./images/Augnex5.mp4"
import "./Augnex.css"
import ProjectCard from "../../ProjectCard"

function Augnex() {
  return (
    <div className="DetailsPage">
      <h1 className="project-details-heading">Augnex</h1>
      <div className="all-details">
        <ProjectCard
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-right"}
          animType2="flip-left"
          content="Augnex is an AR-based(Augmented Reality) web application. This project aims to enhance the navigational experience in the campus
          by integrating Augmented Reality with maps. It enable new people to find places and venues in campus.Augnex is a web-based application that guides users to
          their destination from their current location using Augmented Reality(AR)."
          imgUrl={augnexImagePath}
          name="Augnex"
          showKnowMore="false"
        />
        <section className="githubRepoSection" data-aos="fade-up">
          <h1 data-aos="fade-up">Github Repositories</h1>

          <div className="repos">
            <a
              className="repoLink"
              href="https://github.com/iitsuraj/Augnex"
              target="blank"
            >
              <button type="button" className="btn btn-outline-light">
                Link 1
              </button>
            </a>
            <a
              className="repoLink"
              href="https://github.com/Hemanthpothu/AR-Institute-GEO-Location/blob/main/AR_Project.pdf"
              target="blank"
            >
              <button type="button" className="btn btn-outline-light">
                Link 2
              </button>
            </a>
          </div>
        </section>

        <section className="imageSection" data-aos="fade-up">
          <h1 data-aos="fade-up">Images and Videos</h1>

          <div className="images">
            <img
              className="image"
              src={augnexImagePath2}
              alt=""
              height="200px"
              width="200px"
            />
            <img
              className="image"
              src={augnexImagePath3}
              alt=""
              height="200px"
              width="200px"
            />
            <img
              className="image"
              src={augnexImagePath4}
              alt=""
              height="200px"
              width="200px"
            />
          </div>
        </section>
        <section>
          <div className="video">
            <ReactPlayer url={augnexVideoPath1} controls />
            <ReactPlayer url={augnexVideoPath2} controls />
          </div>
        </section>

        <section className="augnexSection" data-aos="fade-up">
          <h1 data-aos="fade-up">Augnex</h1>

          <div className="augnexWeb">
            <div className="augnexLink" data-aos="fade-up">
              <a href="https://iitsuraj.github.io/Augnex/" target="blank">
                <button type="button" className="btn btn-outline-light">
                  Link
                </button>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Augnex
